import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.css';
export function Spinner() {
    return (_jsx("svg", { viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className: styles.spinner, children: _jsx("path", { d: 'M5 8C5 6.34315 6.34315 5 8 5', stroke: 'black', strokeWidth: '1.5', strokeLinecap: 'round' }) }));
}
